<template>
    <v-card v-if="model.id" class="elevation-2">
      <v-card-title class="text-h5">
        <h2 class="font-weight-bold text--primary"> Factura </h2>
      </v-card-title>
      <v-card-subtitle class="title text--black font-weight-black font-weight-bold">
          {{`[ ${model.folio} ]`}}
      </v-card-subtitle>
      <v-tabs v-model="tab" background-color="primary" align-with-title dark>
        <v-tabs-slider color="white"></v-tabs-slider>
        <v-tab href="#General">General</v-tab>
        <!-- <v-tab href="#two" @click="viewEquipo()">Equipo Computo</v-tab> -->
        <v-tab href="#Movimientos" @click="viewMovs(model.folio)">Bitácora de Movimientos</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
          <!-- General -->
          <v-tab-item value="General">
            <v-card width="auto" outlined>
                <v-card-text>

<v-row dense>
    <v-col cols="12" sm="12" md="6">
        <label class="font-weight-bold subtitle-1 text--primary">Folio fiscal: </label>
        <p class="font-weight-bold text--secondary">
            {{model.descripcion.folio_fiscal}}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="6">
        <label class="font-weight-bold subtitle-1 text--primary">Numero de factura: </label>
        <p class="font-weight-bold text--secondary">
            {{model.descripcion.numero_factura}}
        </p>
    </v-col>

    <v-col cols="12" sm="12" md="6">
        <label class="font-weight-bold subtitle-1 text--primary">Concepto general: </label>
        <p class="font-weight-bold text--secondary">
            {{model.descripcion.concepto_general}}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="6">
        <label class="font-weight-bold subtitle-1 text--primary">Proveedor: </label>
        <p class="font-weight-bold text--secondary">
            {{model.proveedor.rfc }} -
            {{model.proveedor.nombre }}
        </p>
    </v-col>

    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Subtotal: </label>
        <p class="font-weight-bold text--secondary">
            $ {{model.descripcion.subtotal_impuestos}}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Impuestos: </label>
        <p class="font-weight-bold text--secondary">
            $ {{model.descripcion.impuestos}}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="4" v-if="model.descripcion.descuento">
        <label class="font-weight-bold subtitle-1 text--primary">Descuento: </label>
        <p class="font-weight-bold text--secondary">
            {{model.descripcion.descuento}}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="4" v-if="model.descripcion.impuestos_retenidos">
        <label class="font-weight-bold subtitle-1 text--primary">ISR: </label>
        <p class="font-weight-bold text--secondary">
            {{model.descripcion.impuestos_retenidos}}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Total con impuestos: </label>
        <p class="font-weight-bold text--secondary">
            $ {{model.descripcion.total_con_impuestos}}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="12">
        <label class="font-weight-bold subtitle-1 text--primary">Partidas: </label>
        <p v-for="(p) in model.partidas" :key="p.id" class="font-weight-bold text--secondary">
            {{p.cuenta}} - {{p.nombre}} - ${{p.pivot.monto}}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="12" v-if="model.descripcion.retencion">
        <label class="font-weight-bold subtitle-1 text--primary">Retencion: </label>
        <p class="font-weight-bold text--secondary">
            {{model.descripcion.retencion}} %
        </p>
    </v-col>

    <v-col cols="12" sm="12" md="12" v-if="model.tipo_contratacion">
        <label class="font-weight-bold subtitle-1 text--primary">Tipo de contratacion: </label>
        <p class="font-weight-bold text--secondary">
            {{model.tipo_contratacion.nombre}}
        </p>
    </v-col>
</v-row>
</v-card-text>
          </v-card>
          </v-tab-item>
          <!-- Inventario -->
          <v-tab-item value="two">
            <v-card width="auto" outlined>
              <v-card-text>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- Bitacorra -->
          <v-tab-item value="Movimientos">
            <v-card width="auto" outlined>
              <v-card-text>
                <v-row dense>
                  <v-col v-if="showMovs" cols="12">
                    <ViewMovementsField :itemAction="movs" />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
      </v-tabs-items>
    </v-card>
    <!--
    <v-card v-if="model.id" class="elevation-2">
      <v-card-text>
      </v-card-text>
    </v-card>
  -->
  </template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import ViewMovementsField from '@/components/fields/specific/ViewMovementsField'
export default {
  props: ['model'],
  data: () => ({
    tab: 0,
    movs: {
      field: 'showMovsDataServer',
      name: '',
      nameid: 'movimientos',
      url: '/procesos/movimientos',
      default: '/procesos/movimientos',
      hidden: true,
      cols: 12
    },
    showMovs: false,
    showEq: false,
    itemInsumos: {}
  }),
  components: {
    ViewMovementsField
  },
  methods: {
    ...mapMutations(['SHOW_DIALOG_MAIN']),
    successAction (item) {
      this[item.action](item)
    },
    addInsumosView (item) {
      this.itemInsumos = {}
      this.itemInsumos = Object.assign({}, item.item)
      this.SHOW_DIALOG_MAIN({ type: 'addInsumos', with: 900, title: 'Agregar Insumos' })
    },
    returnedInsumosView (item) {},
    viewMovs (folio) {
      this.showMovs = false
      this.movs.url = `${this.movs.default}?folio=${folio}&mov=all`
      setTimeout(() => { this.showMovs = true }, 200)
    },
    viewEquipo () {
    /*
        if (this.model.descripcion.equipo) return
        this.showEq = false
        const router = this.get_urls['catalogo.familias-caracteristica.formulario']
        this.urlGetServiceActionTwo({ url: router, params: `/${this.model.descripcion.inventario.caracteristicas.familia_id}`, replace: '/{id}' })
        setTimeout(() => { this.showEq = true }, 200)
    */
    }
  },
  computed: {
    ...mapGetters(['get_dialogMain'])
  },
  watch: {
    model (obj) {
      this.tab = 0
    }
  }
}
</script>
<style>
</style>
